import type { PropsWithChildren } from 'react';

import { BudgetCategoryCardAttributesStyled } from './styles/BudgetCategoryCardAttributesStyled'
import { BudgetCategoryCardAttributesRow } from '../BudgetCategoryCardAttributesRow'

export interface IBudgetCategoryCardAttributesProps {}

export const BudgetCategoryCardAttributes = ({
  children,
}: PropsWithChildren<IBudgetCategoryCardAttributesProps>) => {
  return (
    <BudgetCategoryCardAttributesStyled>
      <table>{children}</table>
    </BudgetCategoryCardAttributesStyled>
  )
}

BudgetCategoryCardAttributes.displayName = 'BudgetCategoryCardAttributes'
BudgetCategoryCardAttributes.Row = BudgetCategoryCardAttributesRow
